module.exports = __webpack_public_path__ + "static/media/36_tn.2f63711b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/36_tn.jpg
// module id = 524
// module chunks = 0